import { facade } from '@noeldemartin/utils';

import Service from './Goals.state';

export class GoalsService extends Service {}

export default facade(GoalsService);
